var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ul", { staticClass: "pagination" }, [
    _c("div", { staticClass: "icons-container" }, [
      _c("li", { staticClass: "pagination-item" }, [
        _c("button", {
          class: [{ inactive: _vm.isInFirstPage }, _vm.icons.back, "icon"],
          attrs: { type: "button", disabled: _vm.isInFirstPage },
          on: { click: _vm.onClickFirstPage },
        }),
      ]),
      _c("li", { staticClass: "pagination-item" }, [
        _c("button", {
          class: [{ inactive: _vm.isInFirstPage }, _vm.icons.angleLeft, "icon"],
          attrs: { type: "button", disabled: _vm.isInFirstPage },
          on: { click: _vm.onClickPreviousPage },
        }),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "numbers-container" },
      _vm._l(_vm.pages, function (page) {
        return _c("li", { staticClass: "pagination-item" }, [
          _c(
            "button",
            {
              class: { active: _vm.isPageActive(page.name) },
              attrs: {
                type: "button",
                disabled: page.isDisabled,
                "aria-label": `Go to page number ${page.name}`,
              },
              on: {
                click: function ($event) {
                  return _vm.onClickPage(page.name)
                },
              },
            },
            [_vm._v(_vm._s(_vm.formatPage(page.name)))]
          ),
        ])
      }),
      0
    ),
    _c("div", { staticClass: "icons-container" }, [
      _c("li", { staticClass: "pagination-item" }, [
        _c("button", {
          class: [{ inactive: _vm.isInLastPage }, _vm.icons.angleRight, "icon"],
          attrs: { type: "button", disabled: _vm.isInLastPage },
          on: { click: _vm.onClickNextPage },
        }),
      ]),
      _c("li", { staticClass: "pagination-item" }, [
        _c("button", {
          class: [{ inactive: _vm.isInLastPage }, _vm.icons.advance, "icon"],
          attrs: { type: "button", disabled: _vm.isInLastPage },
          on: { click: _vm.onClickLastPage },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }